/**
 * State do dashboard de check-in.
 *
 * Os filtros vivem em memória durante a sessão da rota e são persistidos
 * no localStorage por usuário (via mutações). Re-hidratado em `mounted` da
 * página principal.
 */
const startOfToday = () => {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

export default {
  // Filtros aplicados
  filters: {
    period: 'today', // 'last_hour' | 'today' | '7d' | 'custom'
    from: startOfToday(),
    to: new Date(),
    tagIds: [],
    operatorId: null
  },

  // Bucket atual da timeline. Auto-selecionado quando o período muda,
  // mas pode ser sobrescrito manualmente pelo usuário.
  bucket: '5min',

  // Dados carregados
  overview: null,
  timeline: [],
  insights: [],
  byTag: [],
  // Window específica do TagFlowGrid (sobrescreve o range global só pra
  // ocupação por estande). null = usa filtro global.
  byTagWindowMinutes: null,
  heatmap: { tags: [], matrix: {} },
  operators: [],
  anomalies: null,
  funnel: null,
  flow: { nodes: [], links: [], total_transitions: 0, unique_tags: 0 },
  topLocations: [],

  // Live feed via Pusher (Fase 7) — array de leituras recentes recebidas
  // em real-time. Capped em LIVE_FEED_MAX no mutation.
  liveFeed: [],
  liveFeedConnected: false,
  liveFeedPaused: false,

  // Drawer analítico de UMA tag — null quando fechado
  tagDetail: null,
  tagDetailLoading: false,
  tagDetailBucket: '1h',

  // Análise por campo DENTRO do drawer — escopo: visitantes desse local
  // específico. Suporta cruzamento de 2 campos (modo cross).
  tagDetailField: null,
  tagDetailFieldSecondary: null,
  tagDetailFieldData: null,
  tagDetailFieldLoading: false,

  // Drawer analítico de UM operador — espelha o tagDetail mas com escopo
  // user_operator_id. Mesma feature de perfil + cruzamento.
  operatorDetail: null,
  operatorDetailLoading: false,
  operatorDetailField: null,
  operatorDetailFieldSecondary: null,
  operatorDetailFieldData: null,
  operatorDetailFieldLoading: false,

  // Análise por campo customizado. `primary` e `secondary` são objects
  // { source: 'standard'|'form_field'|'rc_field', id }. Null até o usuário
  // escolher. `secondary` opcional (modo single quando null).
  fieldAnalysis: {
    primary: null,
    secondary: null,
    data: null,
    isLoading: false
  },

  // Opções de filtro (tags, operadores, campos disponíveis)
  // `event` vem do backend (Setting.event_init_date/end_date) e contém:
  //   { init_date, end_date, days: [{ index, date }], status, today }
  // status ∈ { unconfigured, upcoming, ongoing, finished }
  filterOptions: {
    tags: [],
    operators: [],
    fields: [],
    active_dates: [],
    event: null
  },

  // Controle de polling
  pollingHandle: null,
  isLoading: false,
  isFirstLoad: true,
  lastUpdate: null,
  error: null
}
